import {all, call, fork, put, takeEvery} from "redux-saga/effects";
import {appInfo} from "apollo/queries/appInfo";
import {dashboardAppInfo} from "apollo/queries/dashboardAppInfo";
import {dashboardAppInfoByTime} from "apollo/queries/dashboardAppInfoByTime";
import {getAccountApplications} from "apollo/queries/getAccountApplications";
import {getApplicationsWithAccounts} from "apollo/queries/getApplicationsWithAccounts";
import {getApplication} from "apollo/queries/getApplication";
import {getCustomers} from "apollo/queries/getCustomers";
import {getCustomerInfo} from "apollo/queries/getCustomerInfo";
import {updateApplicationMutation} from "apollo/mutations/updateApplication";
import {createApplicationMutation} from "apollo/mutations/createApplication";
import {deleteApplicationMutation} from "apollo/mutations/deleteApplication";
import {getSubKeys} from "apollo/queries/getSubKeys";
import {generateSubKeyMutation} from "apollo/mutations/generateSubKey";
import {deleteSubKeyMutation} from "apollo/mutations/deleteSubKey";
import {generateKeyMutation} from "apollo/mutations/generateKey";
import {fetchAppInfoSuccess, fetchApplicationsSuccess, updateApplicationSuccess,
createApplicationSuccess, deleteApplicationSuccess, fetchCustomersSuccess, fetchCustomerInfoSuccess,
fetchDashboardAppInfoSuccess, fetchDashboardAppInfoByTimeSuccess, fetchApplicationSuccess,
fetchSubKeysSuccess, generateSubKeySuccess, deleteSubKeySuccess, generateKeySuccess}
from "../actions/Application";
import {fetchError} from "../actions/Common";
import {client} from "apollo/client";

import {
  APPINFO,
  CREATEAPPLICATION,
  UPDATEAPPLICATION,
  DELETEAPPLICATION,
  FETCHAPPLICATIONS,
  FETCHAPPLICATION,
  FETCHCUSTOMERS,
  FETCHCUSTOMERINFO,
  DASHBOARDAPPINFO,
  DASHBOARDAPPINFOBYTIME,
  CHANGEAPPLICATION,
  FETCHSUBKEYS,
  GENERATESUBKEY,
  DELETESUBKEY,
  GENERATEKEY
} from "constants/ActionTypes";

const appInfoRequest = async (applicationId) => {
  try {
    let { data, error } = await client.query({
      query: appInfo,
      variables: {
        applicationId: applicationId,
      },
      fetchPolicy: 'network-only'
    });

    console.log('data error', data, error);

    if (data) {
      return Promise.resolve(data);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const dashboardAppInfoRequest = async (applicationId) => {
  try {
    let { data, error } = await client.query({
      query: dashboardAppInfo,
      variables: {
        applicationId: applicationId,
      },
      fetchPolicy: 'network-only'
    });

    console.log('data error', data, error);

    if (data) {
      return Promise.resolve(data);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const dashboardAppInfoByTimeRequest = async (applicationId, type) => {
  try {
    let { data, error } = await client.query({
      query: dashboardAppInfoByTime,
      variables: {
        applicationId: applicationId,
        type: type
      },
      fetchPolicy: 'network-only'
    });

    console.log('data error', data, error);

    if (data) {
      return Promise.resolve(data);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const getApplicationsRequest = async (type) => {

  let { data, error } = await client.query({
    query: type == 'super' ? getApplicationsWithAccounts : getAccountApplications,
    variables: {
    },
    fetchPolicy: 'network-only'
  });

  console.log('data', data);
  console.log('error', error);

  if (data) {
    return Promise.resolve(data);
  } else {
    return Promise.reject(error);
  }
}

const getApplicationRequest = async (applicationId) => {
  let { data, error } = await client.query({
    query: getApplication,
    variables: {
      applicationId: applicationId
    },
    fetchPolicy: 'network-only'
  });

  console.log('data', data);
  console.log('error', error);

  if (data) {
    return Promise.resolve(data);
  } else {
    return Promise.reject(error);
  }
}

const createApplicationRequest = async (input) => {
  console.log('input', input);
  let { data, error } = await client.mutate({
    mutation: createApplicationMutation,
    variables: {
      input: input
    }
  });

  if (data) {
    return Promise.resolve(data);
  } else {
    return Promise.reject(error);
  }
}

const updateApplicationRequest = async (applicationId, input) => {

  let { data, error } = await client.mutate({
    mutation: updateApplicationMutation,
    variables: {
      input: input
    }
  });

  if (data) {
    return Promise.resolve(data);
  } else {
    return Promise.reject(error);
  }
}

const deleteApplicationRequest = async (input) => {
  console.log('input', input);

  try {
    let { data, error } = await client.mutate({
      mutation: deleteApplicationMutation,
      variables: {
        applicationId: input
      }
    });

    console.log('data', data);

    if (data.deleteApplicationById.rows_deleted > 0) {
      return Promise.resolve(data);
    } else {
      return Promise.reject("Application not found");
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const getCustomersRequest = async (applicationId) => {
  try {
    let { data, error } = await client.query({
      query: getCustomers,
      variables: {
        application: applicationId
      },
      fetchPolicy: 'network-only'
    });

    console.log('data', data);
    console.log('error', error);

    if (data) {
      return Promise.resolve(data);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('error', e);
    return Promise.reject(e);
  }
}

const getCustomerInfoRequest = async (customerId) => {
  try {
    let { data, error } = await client.query({
      query: getCustomerInfo,
      variables: {
        customerId: customerId
      },
      fetchPolicy: 'network-only'
    });

    console.log('data', data);
    console.log('error', error);

    if (data) {
      return Promise.resolve(data);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('error', e);
    return Promise.reject(e);
  }
}

const fetchSubKeysRequest = async (application) => {
  let { data, error } = await client.query({
    query: getSubKeys,
    variables: {
      application: application
    },
    fetchPolicy: 'network-only'
  });

  console.log('data', data);
  console.log('error', error);

  if (data) {
    return Promise.resolve(data);
  } else {
    return Promise.reject(error);
  }
}

const generateSubKeyRequest = async (input) => {
  console.log('input', input);
  let { data, error } = await client.mutate({
    mutation: generateSubKeyMutation,
    variables: {
      input: input
    }
  });

  if (data) {
    return Promise.resolve(data);
  } else {
    return Promise.reject(error);
  }
}

const deleteSubKeyRequest = async (subKeyId) => {
  let { data, error } = await client.mutate({
    mutation: deleteSubKeyMutation,
    variables: {
      subKeyId
    }
  });

  if (data) {
    return Promise.resolve(data);
  } else {
    return Promise.reject(error);
  }
}

const generateKeyRequest = async (input) => {
  console.log('input', input);
  let { data, error } = await client.mutate({
    mutation: generateKeyMutation,
    variables: {
      input: input
    }
  });

  if (data) {
    return Promise.resolve(data);
  } else {
    return Promise.reject(error);
  }
}

function* getAppInfo({payload}) {
  const {applicationId} = payload;

  try {
    const fetchedAppInfo = yield call(appInfoRequest, applicationId);
    yield put(fetchAppInfoSuccess(applicationId, fetchedAppInfo));
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* getDashboardAppInfo({payload}) {
  const {applicationId} = payload;

  try {
    const fetchedAppInfo = yield call(dashboardAppInfoRequest, applicationId);
    yield put(fetchDashboardAppInfoSuccess(applicationId, fetchedAppInfo));
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* getDashboardAppInfoByTime({payload}) {
  const {applicationId, type} = payload;

  try {
    const fetchedAppInfo = yield call(dashboardAppInfoByTimeRequest, applicationId, type);
    yield put(fetchDashboardAppInfoByTimeSuccess(applicationId, type, fetchedAppInfo));
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* getApplications({payload}) {
  const {type} = payload;
  try {
    const fetchedApplications = yield call(getApplicationsRequest, type);
    yield put(fetchApplicationsSuccess(fetchedApplications));
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* getApplicationCall({payload}) {
  const {applicationId} = payload;

  try {
    const fetchedApplication = yield call(getApplicationRequest, applicationId);
    yield put(fetchApplicationSuccess(fetchedApplication));
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* getCustomersCall({payload}) {
  const {applicationId} = payload;

  try {
    const fetchedCustomers = yield call(getCustomersRequest, applicationId);
    yield put(fetchCustomersSuccess(fetchedCustomers, applicationId));
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* getCustomerInfoCall({payload}) {
  const {customerId} = payload;

  try {
    const fetchedCustomerInfo = yield call(getCustomerInfoRequest, customerId);
    yield put(fetchCustomerInfoSuccess(fetchedCustomerInfo, customerId));
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* createApplicationCall({payload}) {

  try {
    const {createApplication} = yield call(createApplicationRequest, payload);
    yield put(createApplicationSuccess(createApplication));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* updateApplicationCall({payload}) {

  try {
    const {updateApplication} = yield call(updateApplicationRequest,
      payload.applicationId, payload);
    yield put(updateApplicationSuccess(updateApplication));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* deleteApplicationCall({payload}) {

  try {
    const deletedApplication = yield call(deleteApplicationRequest, payload);
    yield put(deleteApplicationSuccess(deletedApplication));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* changeApplicationCall({payload}) {
  localStorage.setItem('bms-current-application', JSON.stringify(payload));
}

function* fetchSubKeysCall({payload}) {

  try {
    const fetchedSubKeys = yield call(fetchSubKeysRequest, payload);
    yield put(fetchSubKeysSuccess(fetchedSubKeys));
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* generateSubKeyCall({payload}) {

  try {
    const generatedSubKey = yield call(generateSubKeyRequest, payload);
    yield put(generateSubKeySuccess(generatedSubKey));
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* deleteSubKeyCall({payload}) {
  try {
    const deletedSubKey = yield call(deleteSubKeyRequest, payload);
    yield put(deleteSubKeySuccess(deletedSubKey));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* generateKeyCall({payload}) {
  try {
    const generatedKey = yield call(generateKeyRequest, payload);
    yield put(generateKeySuccess(generatedKey, payload.applicationId));
  } catch (error) {
    yield put(fetchError(error));
  }
}

export function* fetchAppInfo() {
  yield takeEvery(APPINFO, getAppInfo);
}

export function* fetchDashboardAppInfo() {
  yield takeEvery(DASHBOARDAPPINFO, getDashboardAppInfo);
}

export function* fetchDashboardAppInfoByTime() {
  yield takeEvery(DASHBOARDAPPINFOBYTIME, getDashboardAppInfoByTime);
}

export function* fetchApplications() {
  console.log('fetchApplications');
  yield takeEvery(FETCHAPPLICATIONS, getApplications);
}

export function* fetchApplication() {
  console.log('fetchApplications');
  yield takeEvery(FETCHAPPLICATION, getApplicationCall);
}

export function* updateApplication() {
  yield takeEvery(UPDATEAPPLICATION, updateApplicationCall);
}

export function* createApplication() {
  yield takeEvery(CREATEAPPLICATION, createApplicationCall);
}

export function* changeApplication() {
  yield takeEvery(CHANGEAPPLICATION, changeApplicationCall);
}

export function* deleteApplication() {
  yield takeEvery(DELETEAPPLICATION, deleteApplicationCall);
}

export function* fetchSubKeys() {
  yield takeEvery(FETCHSUBKEYS, fetchSubKeysCall);
}

export function* generateSubKey() {
  yield takeEvery(GENERATESUBKEY, generateSubKeyCall);
}

export function* deleteSubKey() {
  yield takeEvery(DELETESUBKEY, deleteSubKeyCall);
}

export function* generateKey() {
  yield takeEvery(GENERATEKEY, generateKeyCall);
}

export function* fetchCustomers() {
  yield takeEvery(FETCHCUSTOMERS, getCustomersCall);
}

export function* fetchCustomerInfo() {
  yield takeEvery(FETCHCUSTOMERINFO, getCustomerInfoCall);
}

export default function* rootSaga() {
  yield all([fork(fetchAppInfo),
  fork(updateApplication),
  fork(createApplication),
  fork(deleteApplication),
  fork(fetchApplications),
  fork(fetchApplication),
  fork(fetchCustomers),
  fork(fetchCustomerInfo),
  fork(fetchDashboardAppInfo),
  fork(fetchDashboardAppInfoByTime),
  fork(changeApplication),
  fork(fetchSubKeys),
  fork(generateSubKey),
  fork(deleteSubKey),
  fork(generateKey)
  ]);
}
